module.exports = __webpack_public_path__ + "static/calendar-year-2019-2020-e240e1dd6d23a2a76b24a242f145d155.pdf";